module.exports = __webpack_public_path__ + "img/chen.8fe99ce0.png";